import React, { useEffect, useState } from 'react';
import Sidebar from '../Sidebar/Sidebar';
import DashboardList from '../DashboardList/DashboardList';

const Prescriptions = () => {
    const [allPatients, setAllPatients] = useState([]);

    useEffect(()=> {
        fetch('http://localhost:5000/Appointments')
        .then(res => res.json())
        .then( data => {
            setAllPatients(data);
        })
    },[])

    return (
        <section style={{background: '#f4fdfb'}}>
            <div className="ps-0 container-fluid row">
                <div className="col-md-2">
                    <Sidebar></Sidebar>
                </div>
                <div className="col-md-10">
                <h5 className='mt-5'>Prescriptions</h5>
                    <DashboardList prescription={true} title='All Prescriptions' appointments={allPatients}></DashboardList>
                </div>
            </div>
        </section>
    );
};

export default Prescriptions;